var map = {
	"./4-CN.png": "jYVw",
	"./4-EN.png": "5i4j"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "u3BX";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_m ^\.\/4\-.*\.png$
// module id = u3BX
// module chunks = 1